module.exports = __webpack_public_path__ + "static/img/honor_6.348426f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/honor_6.jpg
// module id = dnhk
// module chunks = 0